<template>
  <el-dialog
    title="全部评论"
    v-if="visible"
    width="1000px"
    :visible.sync="visible"
    :before-close="(_) => $emit('visible', false)"
  >
    <div class="comment-all" ref="comment-all">
      <Comment ref="comment" :box="true" @handleJump="handleJump" />
    </div>
  </el-dialog>
</template>

<script>
import Comment from "@/components/module/comment.vue";
export default {
  name:'CommentAll',
  components: { Comment },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 当前视频
    info: {
      type: Object,
    },
    // 交互配置
    option: {
      type: Object,
      default: () => {
        return {
          // 列表api
          listApi: (_) => {},
          // 点赞api
          likeApi: (_) => {},
          // 评论api
          postApi: (_) => {},
          // 回复api
          postReplyApi: (_) => {},
          // 删除api
          delApi: (_) => {},
        };
      },
    },
  },
  model: {
    prop: "visible",
    event: "visible",
  },
  watch: {
    visible(val) {
      setTimeout((_) => {
        val ? this.$refs["comment"].init(this.option) : "";
      }, 100);
    },
  },
  methods: {
    handleJump(top) {
      this.$refs["comment-all"].scrollTop = top - 84;
    },
  },
};
</script>

<style lang="scss" scoped>
.comment-all {
  max-height: 600px;
  overflow: auto;
}
</style>
